export const LANDING_PAGE_LOADER = "LANDING_PAGE_LOADER";
export const LANDING_PAGE_SUCCESS = "LANDING_PAGE_SUCCESS";
export const LANDING_PAGE_FAILURE = "LANDING_PAGE_FAILURE";
export const LANDING_PAGE_RESET = "LANDING_PAGE_RESET";
